import * as echarts from 'echarts';
import React, { useEffect } from 'react';
import { useRef } from 'react';

export default function RadarChart(props: any) {
  const {
    radarItemArr = [],
    radarLabelArr = [],
    selectedTopic = 'All Topic'
  } = props
  const ref = useRef<HTMLDivElement>(null);

  const formatterTooltip = (_param: string | any[]) => {
    const param = _param;//moveZero(_param);  要区别排名的话是顺序，其他是倒序
    let returnStr = `
      <div style="font-size:12px;">
        <div style="color:#EBECF1;opacity:0.85;text-align: left;margin-right:20px;display:inline-block;font-weight: 400;">
          ${'Sentiment Score'}
        </div>
        <div style="color:#EBECF1;opacity:0.9;float:right;display:inline-block;font-weight: 700;">
          ${radarItemArr[param.seriesIndex * 1 - 1]}
        </div>
      </div>`;
    return returnStr
  };

  const getSeries = () => {
    let nArr = radarItemArr.map((item: any, index: any) => {
      let _tmp = new Array(radarItemArr.length + 1).fill(1000);
      _tmp[index] = item;
      return _tmp;
    })

    let tmpArr = [{
      type: 'radar', //绘制总的图形不设置拐点
      radarIndex: 1,
      data: [
        {
          value: radarItemArr,
          symbolSize: 4,
          lineStyle: {
            width: 2,
            color: '#376AE7'
          },
          itemStyle: {
            normal: {
              borderWidth: 1,
              color: '#000',
              borderColor: '#376AE7',
              // show:false
            }
          },
          areaStyle: {
            normal: {
              color: 'rgba(55, 106, 231, 0.15)'
            }
          },
          emphasis: {
            disabled: true,
          },
        }
      ],
      silent: true,
      z: 1 //图层是一层一层叠加，所以这个也是一级一级递增
    }]

    const tmpLastArr = radarItemArr.map((item: any, index: any) => (
      {
        type: 'radar', //绘制第一个点
        radarIndex: 1,
        name: radarLabelArr[index],
        z: index + 2, //图层是一层一层叠加，所以这个也是一级一级递增
        data: [
          {
            value: nArr[index],
            symbolSize: 7,
            itemStyle: {
              color: radarLabelArr[index] === selectedTopic ? '#fff':'#376AE7',
              borderColor: radarLabelArr[index] === selectedTopic ? '#376AE7' : '#fff',
              borderWidth: 1,
            },
            lineStyle: {
              width: 0,
              labelLine: {
                show: false   //隐藏标示线
              }
            },
            emphasis: {
              symbolSize: 10,
              itemStyle: {
                color: '#fff',
                borderColor: '#376AE7',
                borderWidth: 2
              },
            },
          }
        ],
        tooltip: {
          show: true,
          borderWidth: '0',
          // backgroundColor: '#262832F2',
          formatter: formatterTooltip,
          backgroundColor: 'rgba(0,0,0,0)'
        },
      }
    ))

    return tmpArr.concat(tmpLastArr);
  }

  const getIndicator = () => {
    return radarLabelArr.map((item: any) => {
      return {
        text: item,
        max: 5
      }
    })
  }

  const getOptions = () => {
    return {
      radar: [
        {
          splitLine: {
            lineStyle: {
              color: '#000'
            }
          },

        },
        {
          indicator: getIndicator(),
          splitArea: {
            show: true,
            areaStyle: {
              color: 'rgba(255,0,0,0)', // 图表背景的颜色
            },
          },
          axisName: {
            show: true,
            color: '#000',
          },
          axisLine: {
            lineStyle: {
              color: '#ebecec'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#ebecec'
            }
          },
        }
      ],
      series: getSeries(),
      tooltip: {
        show: false,
        trigger: 'item',
        backgroundColor: 'rgba(0,0,0,0)'
      }
    }
  }

  const handleResize = (chart) => {
    if (ref?.current) {
      chart.resize();
    }
  };

  useEffect(() => {
    let _chart;
    let listener: null | (() => void) = null;

    if (ref.current) {
      const options = getOptions();
      // canvas
      _chart = echarts.init(ref.current, undefined, { renderer: 'canvas' });
      _chart.setOption(options, { notMerge: true });
      listener = () => {
        handleResize(_chart);
      };

      window.addEventListener('resize', listener);
    }

    return () => {
      if (_chart && listener !== null) {
        window.removeEventListener('resize', listener);
        _chart.off();
      }
    };
  }, [props]);

  const chartStyle = {
    height: '300px',
    width: '100%',
  };

  return (
    <div style={{ ...chartStyle, textAlign: 'center' }}>
      <div ref={ref} style={chartStyle}></div>
    </div>
  );

}
